import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useTokenRefresh } from '../hooks/useTokenRefresh';
import { useAuthStore } from '../stores';
import type { UserRole } from '../stores';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Belirli roller için erişim kısıtlaması. Boş bırakılırsa sadece authentication kontrolü yapılır. */
  allowedRoles?: UserRole[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);

  useTokenRefresh();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Role kontrolü
  if (allowedRoles && allowedRoles.length > 0) {
    const userRole = user?.role;
    if (!userRole || !allowedRoles.includes(userRole)) {
      // Yetkisiz erişim - ana sayfaya yönlendir veya unauthorized sayfası göster
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
}
